import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactTooltip from "react-tooltip";
import Toast from "react-bootstrap/Toast";
import { InputGroup } from "react-bootstrap";
import axios from "axios";
import { QuestionCircle, Eye, EyeSlash } from "react-bootstrap-icons";
import { REQUIRED_FIELDS, FINANCIALPROFESSIONAL } from "./constants";
import {
    emailValidation,
    userNameValidation,
    emailVerifyMatch,
    ssnValidation
} from "./validation";
import { analytics } from "./analytics";
import { Header, Footer, DisclaimerPolicyOwner } from "./components";
import TermsAndConditions from "./Terms&ConditionsFP";
import "react-datepicker/dist/react-datepicker.css";
import { getIPAddress } from "./utils/getIPAddress";


const FPEnroll = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        userName: "",
        password: "",
        verifyPassword: "",
        tin: "",
        policyNumber: "",
        middleName: "",
        state: "",
        zipCode: "",
        suffix: "",
        ssn: "",
        tinType: "",
        saidCode: "",
        role: "producer",
        firmName: "",
        firmCode: "",
        app:searchParams.get("app")
    });

    const [termsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);
    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        userName: "",
        password: "",
        verifyPassword: "",
        tin: "",
        policyNumber: "",
        middleName: "",
        state: "",
        zipCode: "",
        suffix: "",
        tinType: "",
        saidCode: "",
        role: "",
        ssn: ""
    });
    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [submitting, setsubmitting] = useState(false);
    const [showSSN, setShowSSN] = useState(false);
    const [showTIN, setShowTIN] = useState(false);

    const toggleSSNVisibility = () => {
        setShowSSN(!showSSN);
    };

    const toggleTINVisibility = () => {
        setShowTIN(!showTIN);
    };

    const setTermsAndConditions = (e) => {
        setTermsAndConditionsOpen(true);
    };

    const closeTermsAndConditions = (value) => {
        setTermsAndConditionsOpen(value);
    };

    const handleCancel = (e) => {
        window.location.href = "/login/account/fp-landing-page.html";
    };
    useEffect(() => {
        analytics();
    }, []);

    useEffect(() => {
        const role = FINANCIALPROFESSIONAL;
        const requiredFields = REQUIRED_FIELDS[role];

        for (const element of requiredFields) {
            const fieldName = element;
            if (!user[fieldName]) {
                setSubmitDisabled(true);
                return;
            }
            if (
                !user["saidCode"] &&
                !user["policyNumber"] &&
                user.role === "producer"
            ) {
                setSubmitDisabled(true);
                return;
            }
            if (user.role === "producer" && !user["ssn"]) {
                setSubmitDisabled(true);
                return;
            }
        }

        const errorFields = Object.keys(errors);
        for (const element of errorFields) {
            const fieldName = element;
            if (errors[fieldName] !== "") {
                setSubmitDisabled(true);
                return;
            }
        }
    }, [user, errors]);

    useEffect(() => {
        document.title = "Financial Professional Registration | Pacific Life";
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "policyNumber") {
            if (value.length === 0 && !user.saidCode) {
                errorMessage = "Inforce Policy Number must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Policy Number must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.saidCode = "";
            }
        }
        if (name === "saidCode") {
            if (value.length === 0 && !user.policyNumber) {
                errorMessage = "Producer Code must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Said Code must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.policyNumber = "";
            }
        }
        if (name === "dob") {
            if (value.length === 0) {
                errorMessage = "Insured's Date of Birth must be entered";
            } else {
                errorMessage = "";
            }
        }
        if (name === "trustName") {
            if (user.tinType === "T") {
                if (value) {
                    if (/[^[a-zA-Z0-9\s()&,''-]/.test(value)) {
                        errorMessage =
                            "Trust/Organization entered is not valid";
                    }
                }
            }
        }
        if (name === "ssn") {
            const valid = ssnValidation(value);

            if (value.length === 0) {
                errorMessage = "SSN is required.";
            } else {
                if (/\d{3}00\d{4}$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/000\d{6}$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/\d{5}0000$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/^123456789$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/^777777777$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/^888888888$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else if (/^999999999$/.test(value)) {
                    errorMessage = "Please enter a valid SSN.";
                } else {
                    errorMessage =
                        valid || user.role !== "producer"
                            ? ""
                            : "Please enter a valid SSN.";
                }
            }
        }
        if (name === "tin") {
            const valid = ssnValidation(value);
            if (value.length > 0) {
                errorMessage = valid ? "" : "Please enter a valid Tax ID.";
            }
        }
        if (name === "firstName") {
            if (value.length === 0) {
                errorMessage = "First name is required.";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Names can only include letters and standard punctuation.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "middleName") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "suffix") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "lastName") {
            if (value.length === 0) {
                errorMessage = "Last name is required.";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Names can only include letters and standard punctuation.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "email") {
            const emailValid = emailValidation(value);
            if (value.length === 0) {
                errorMessage = "Please enter your email address.";
            } else {
                errorMessage = emailValid
                    ? ""
                    : "Please enter a valid email address (e.g., name@example.com).";
            }
        }

        if (name === "verifyEmail") {
            const emailConfirmValid = emailValidation(value);

            if (value.length === 0) {
                errorMessage = " Please confirm your email address.";
            } else {
                errorMessage = emailConfirmValid
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
            if (!errorMessage) {
                errorMessage = emailVerifyMatch(user.email, value)
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
        }
        if (name === "role") {
            if (user.role) {
                errorMessage =
                    user.role !== "" ? "" : "Please select your role.";
            } else {
                errorMessage = "Please select your role.";
            }
        }

        if (name === "id") {
            const validUserName = userNameValidation(value);
            const emailValid = emailValidation(value);
            const tooShortOrLongUserName =
                value.length < 5 || value.length > 20;
            if (emailValid && !errorMessage) {
                errorMessage = "Do not enter an email in the Username field.";
            }
            if (value) {
                if (value.length === 0) {
                    errorMessage = "Please enter a username.";
                }
            } else {
                errorMessage = "Please enter a username.";
            }
            if (value.indexOf(" ") > -1 && !errorMessage) {
                errorMessage = "Username name should not contain space.";
            }
            if (/[^a-zA-Z0-9-_. ]/.test(value) && !errorMessage) {
                errorMessage =
                    "Username can only include letters, numbers, and underscores.";
            }
            if (validUserName) {
                errorMessage = "";
            } else if (tooShortOrLongUserName && !errorMessage) {
                errorMessage =
                    "Username must be at least 5 characters and no more than 20 characters.";
            }
        }
        if (errorMessage !== "") {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let errMsg = "";
        //const test = JSON.stringify(payload);
        setsubmitting(true);

        const payload = await formatPayloadProfile();
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userenroll/fp/producer/enroll/",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong.  Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong. Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                window.location.href = "/login/account/reg-successful.html";
            }
        } catch (error) {
            setToastMessage(
                errMsg ||
                    error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
        }
        setsubmitting(false);
    };

    const formatPayloadProfile = async () => {
        return {
            id: "",
            firstName: user.firstName,
            lastName: user.lastName,
            ssn: user.ssn,
            tin: user.tin,
            createdBy: user.id,
            email: user.email,
            userId: user.id,
            zipCode: user.zipCode,
            roles: [user.role],
            middleName: user.middleName,
            password: user.password,
            policyNumber: user.policyNumber,
            ipAddress: await getIPAddress(),
            suffix: user.suffix,
            saidCode: user.saidCode,
            state: user.state,
            companyName: user.firmName,
            firmNumber: user.firmCode,
            app: user.app
        };
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: toastMessage
                                }}
                            ></div>
                        </strong>
                    </Toast.Header>
                </Toast>
            )}
            <Header />
            <div className="mainMyAccount">
                <h1 className="heading">
                    Create a Financial Professional Account
                </h1>
                <div>
                    To register for the Life Insurance Financial Professional
                    websites, you must be contracted and appointed with Pacific
                    Life. To learn more, visit{" "}
                    <a
                        target="_blank"
                        href="https://lifeinsurance.pacificlife.com/home"
                    >
                        LifeInsurance.PacificLife.com
                    </a>
                </div>
                <Form
                    onKeyDown={(e) => {
                        if (e.key === "Enter") e.preventDefault();
                    }}
                >
                    <Row>
                        <Col sm={12}>
                            <label className="sub-title">
                                Personal Information
                            </label>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                                name="firstName"
                                autoComplete="off"
                                maxLength={25}
                                value={user.firstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.firstName}
                            </span>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Middle Initial (Optional)</Form.Label>
                            <Form.Control
                                name="middleName"
                                autoComplete="off"
                                maxLength={25}
                                value={user.middleName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.middleName}
                            </span>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                                name="lastName"
                                autoComplete="off"
                                maxLength={35}
                                value={user.lastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.lastName}
                            </span>
                        </Col>
                        <Col md={3}>
                            <Form.Label>Suffix (Optional)</Form.Label>
                            <Form.Control
                                name="suffix"
                                autoComplete="off"
                                maxLength={5}
                                value={user.suffix}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.suffix}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <ReactTooltip />
                            <Form.Label className="emailClass">
                                Email
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="Website related communications and password reset links will be sent to this email."
                                />
                            </Form.Label>
                            <Form.Control
                                name="email"
                                autoComplete="off"
                                maxLength={60}
                                value={user.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.email}
                            </span>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Confirm Email</Form.Label>
                            <Form.Control
                                name="verifyEmail"
                                autoComplete="off"
                                maxLength={60}
                                value={user.verifyEmail}
                                onChange={handleChange}
                                onPaste={(e) => e.preventDefault()}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.verifyEmail}
                            </span>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Form.Label>Company Name (Optional)</Form.Label>
                            <Form.Control
                                name="firmName"
                                autoComplete="off"
                                maxLength={100}
                                value={user.firmName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.firmName}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <label className="sub-title">
                                Identity Verification
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3">
                            <Form.Label>
                                Social Security Number
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="Used to verify your identity and active contract and appointment status."
                                />
                            </Form.Label>
                            <InputGroup>
                            <Form.Control
                                name="ssn"
                                autoComplete="off"
                                maxLength={9}
                                value={user.ssn}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                type={
                                                showSSN
                                                    ? "text"
                                                    : "password"
                                            }
                            />
                          
                            <InputGroup.Text
                                            onClick={toggleSSNVisibility}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {showSSN ? (
                                                <EyeSlash />
                                            ) : (
                                                <Eye />
                                            )}
                                        </InputGroup.Text>
                          </InputGroup>
                        </Form.Group>
                        <span className="validation-error-message">
                            {errors.ssn}
                        </span>
                        </Col>

                        <Col md={5}>
                         <Form.Group className="mb-3">
                            <Form.Label>
                                Company Tax Identification Number/EIN(Optional)
                            </Form.Label>
                            <InputGroup>
                            <Form.Control
                                name="tin"
                                autoComplete="off"
                                maxLength={9}
                                value={user.tin}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                type={
                                            showTIN
                                                ? "text"
                                                : "password"
                                        }
                            />
                             <InputGroup.Text
                                            onClick={toggleTINVisibility}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {showTIN ? (
                                                <EyeSlash />
                                            ) : (
                                                <Eye />
                                            )}
                                        </InputGroup.Text>
                          </InputGroup>
                           </Form.Group>
                            <span className="validation-error-message">
                                {errors.tin}
                            </span>
                        </Col>

                        <Row>
                            <Col sm={12}>
                                <label className="sub-title">
                                    Enter at least one of the following
                                </label>
                            </Col>
                        </Row>

                        <Col md={4}>
                            <Form.Label>
                                Producer Code (SAID or PCN)
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="A 5 digit contract code provided by Pacific Life; Code must be associated to the tax ID provided above."
                                />
                            </Form.Label>
                            <Form.Control
                                name="saidCode"
                                autoComplete="off"
                                maxLength={10}
                                value={user.saidCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.saidCode}
                            </span>
                        </Col>
                        <Col md={4}>
                            <Form.Label>
                                Inforce Policy
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="Inforce policy number from your Pacific Life Book of Business."
                                />
                            </Form.Label>
                            <Form.Control
                                name="policyNumber"
                                autoComplete="off"
                                maxLength={10}
                                value={user.policyNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.policyNumber}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <label className="sub-title">
                                Login Information
                            </label>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <ReactTooltip />
                            <Form.Label className="createUsername">
                                Username
                                <QuestionCircle
                                    tabIndex="-1"
                                    className="iconClass"
                                    data-tip="Your Username and Password will be used to login to the Life Insurance Financial Professional Portals on the Pacific Life domain."
                                />
                            </Form.Label>
                            <Form.Control
                                name="id"
                                autoComplete="off"
                                maxLength={20}
                                value={user.id}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <span className="validation-error-message">
                                {errors.id}
                            </span>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            &nbsp;&nbsp;By clicking on "Register", you agree to
                            abide by these
                            <a href="#" onClick={setTermsAndConditions}>
                                {" "}
                                terms and conditions.
                            </a>{" "}
                            <br />
                            <TermsAndConditions
                                TermsAndConditionsOpen={termsAndConditionsOpen}
                                CloseTermsAndConditions={
                                    closeTermsAndConditions
                                }
                            ></TermsAndConditions>
                        </Col>
                    </Row>

                    <div className="buttons-myaccount">
                        <Button
                            variant="secondary"
                            type="button"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            onClick={handleSubmit}
                            data-track="analytics"
                            disabled={submitDisabled || submitting}
                        >
                            {submitting ? "Registering" : "Register"}
                        </Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>

                    <div>
                        <a href="/login/account/fp-landing-page.html">
                            Already have an account?
                        </a>
                    </div>
                </Form>

                <DisclaimerPolicyOwner />
            </div>
            <Footer />
        </>
    );
};

export default FPEnroll;
